import React, {useEffect} from 'react';
import {useSetting} from "store/settings";
import {handleSuccessMessages} from "store/auth";
import {Field, Form, Formik} from "formik";
import {Loading, Select} from "components/form";
import {useCore} from "store/core";

const SlidersMenus = (props) => {
   const {dispatch, getSetting, submitSetting, slider_menus, loading} = useSetting();
   const core = useCore();
   const key = "slider_menus"

   useEffect(() => {
      dispatch(getSetting(key));
      core.dispatch(core.getSliders());
      core.dispatch(core.getMenus());
   }, [])

   if (loading) {
      return (<div className="box p-5 flex justify-center">
         <Loading/>
      </div>)
   }
   return (
      <>
         <Formik
            initialValues={slider_menus || {}}
            onSubmit={async (values, {setSubmitting}) => {
               await dispatch(submitSetting({value: values, key},
                  () => handleSuccessMessages("ویرایش اطلاعات انجام شد")))
               setSubmitting(false);
            }}
            enableReinitialize
         >
            {({isSubmitting, dirty}) => (
               <Form>
                  <div className="box rounded p-3">
                     <h3>تنظیمات اسلایدر و منو</h3>
                     <hr className="my-2"/>
                     <div className="">
                        <div className="intro-x grid grid-cols-2 gap-4">
                           <div>
                              <Field
                                 placeholder="انتخاب اسلایدر"
                                 label="انتخاب اسلایدر :"
                                 name="slider"
                                 component={Select}
                                 options={core.sliders || {}}
                              />
                           </div>
                           <div>
                              <Field
                                 placeholder="انتخاب منو"
                                 label="انتخاب منو :"
                                 name="menu"
                                 component={Select}
                                 options={core.menus || {}}
                              />
                           </div>
                           <div>
                              <Field
                                 placeholder="(پلاس)انتخاب اسلایدر"
                                 label="انتخاب اسلایدر(پلاس) :"
                                 name="plus_slider"
                                 component={Select}
                                 options={core.sliders || {}}
                              />
                           </div>
                           <div>
                              <Field
                                 placeholder="(پلاس)انتخاب منو"
                                 label="(پلاس)انتخاب منو :"
                                 name="plus_menu"
                                 component={Select}
                                 options={core.menus || {}}
                              />
                           </div>
                           <div>
                              <Field
                                 placeholder="انتخاب اسلایدر فروشگاه"
                                 label="انتخاب اسلایدر فروشگاه:"
                                 name="shop_slider"
                                 component={Select}
                                 options={core.sliders || {}}
                              />
                           </div>
                           <div>
                              <Field
                                 placeholder="انتخاب منو فروشگاه"
                                 label="انتخاب منو فروشگاه :"
                                 name="shop_menu"
                                 component={Select}
                                 options={core.menus || {}}
                              />
                           </div>
                           <button
                              className="mt-4 btn btn-primary w-20"
                              type="submit"
                              disabled={!!(isSubmitting || !dirty)}
                           >
                              {isSubmitting ? <Loading/> : "ذخیره"}
                           </button>
                        </div>
                     </div>
                  </div>
               </Form>
            )}
         </Formik>
      </>
   )
};

export default SlidersMenus;